import _ from 'lodash'

export function number(value) {
    return '$ '+_.floor(value, 2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}
